/**
 * Accessibility functions for Sub Nav
 * Its primary concern is what happens when focus changes
 */
export const accessibilityDesktopNav = {
  mounted() {
    const nav = this.el;
    const DISPLAY_SUB_NAV_CLASS = 'display-sub-nav';
    /**
     * Handles what happens when the user presses Tab
     * @param {KeyboardEvent} e - A keyboard event
     */
    const handleTab = (): void => {
      const currentActiveElement = document.activeElement;
      const currentNavGroup = currentActiveElement?.closest('.gnav-desktop-nav-item-group');
      setTimeout(() => {
        const foucsHasLeftGroup = !currentNavGroup?.contains(document.activeElement);
        if (foucsHasLeftGroup && currentNavGroup?.classList.contains(DISPLAY_SUB_NAV_CLASS)) {
          currentNavGroup?.classList.remove(DISPLAY_SUB_NAV_CLASS);
        }
      }, 100);
    };

    /**
     * Find the display class and remove it
     * Since there should only be one sub menu open at a time, it is safe to rely on finding
     * the first element that has this class name.
     */
    const handleEsc = (): void => {
      const subMenu = nav.querySelector(`.${DISPLAY_SUB_NAV_CLASS}`);
      subMenu?.classList.remove(DISPLAY_SUB_NAV_CLASS);
    };

    /**
     * Handles all keydown events
     * Currently this only handles 'Tab', but can be expanded to handle
     * other types of keydown events. To handle a new keydown event,
     * add a new case above default matching the desired key . Then, call
     * the desired function in the new case.
     */
    const handleKeyDown = (e) => {
      switch (e.key) {
        case 'Tab':
          handleTab();
          break;

        case 'Escape':
          handleEsc();
          break;

        default:
          break;
      }
    };

    nav.addEventListener('keydown', handleKeyDown);
  }
};
